// src/components/LogoutButton.jsx
import React from 'react';
import { auth } from '../../Logica/firebase/firebase.js';
import { signOut } from 'firebase/auth';

const LogoutButton = () => {
  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Error al cerrar sesión:", error);
    }
  };

  return (
    <button onClick={handleLogout} className="btn btn-secondary">
      Cerrar sesión
    </button>
  );
};

export default LogoutButton;
